// extracted by mini-css-extract-plugin
export var numpadContainer = "_oh-1";
export var phoneButton = "_oh-0";